import React, { useState, useEffect } from 'react';
import {
  Grid, Backdrop, Snackbar, CircularProgress, Typography, TextField, Button, Autocomplete,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// project imports
import SubCard from 'src/components/cards/SubCard';
import ThemeCustomization from 'src/themesNew';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Page from 'src/components/Page';
import {
  Container,
  Card,
  CardHeader,
} from '@material-ui/core';
import {
  Select,
  MenuItem,
  Divider,
  CardContent,
} from '@material-ui/core';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

// ==============================|| PROFILE 1 - PROFILE ACCOUNT ||============================== //

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Role = () => {

  const theme = useTheme();




  const classes = useStyles();


  const SessionUser = getUser();
  const [loading, setLoading] = useState(false);
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [EmployeeNr, setEmployeeNr] = useState(0);
  const [RoleTypes, setRoleTypes] = useState([]);
  const [NewRoleType, setNewRoleType] = useState('');
  const [loadingCombo, setLoadingCombo] = useState(false);
  const [UsersData, setUsersData] = useState([]);
  const [User, setUser] = useState([]);
  const [UserRolesData, setUserRolesData] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [openNewApplicationDialogUser, setOpenNewApplicationDialogUser] = React.useState(false);
  const [userName, setUserName] = useState('');
  const [userCode, setUserCode] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userTopServiceShopCode, setUserTopServiceShopCode] = useState({});
  const [userBusinessType, setUserBusinessType] = useState(-1);

  const [TypeDsc, setTypeDsc] = useState('');
  const handleAddRole = () => {
    if (!User?.Id || !NewRoleType) {
      setresponseMessage('Lütfen yetki tipi ve kullanıcı seçiniz!...');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios.get(`SetApplicationUserRole/${User?.Id}/${NewRoleType}`).then((response) => {
      setLoading(false);
      GetUserRoles(User?.Id);
    }).catch((error) => {
      setLoading(false);
    });
  };




  const handleUsers = (val) => {
    setLoadingCombo(true);
    axios.get(`GetApplicationUserSearch/${val}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setUsersData(response.data);
        } else {
          setUsersData([]);
        }
        setLoadingCombo(false);
      })
      .catch((error) => {
        setUsersData([]); // You can choose to handle the error differently based on your use case.
        setLoadingCombo(false);
      });
  }


  const getEmployeeRole = () => {
    setLoading(true);
    axios.get(`GetApplicationRoles`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setRoleTypes(response.data);
        } else {
          setRoleTypes([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error while fetching employee roles:", error);
        setRoleTypes([]); // You can choose to handle the error differently based on your use case.
        setLoading(false);
      });

  }

  const GetUserRoles = (val) => {
    setLoading(true);
    axios.get(`GetApplicationUserRoles/${val}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setUserRolesData(response.data);
        } else {
          setUserRolesData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        setUserRolesData([]); // You can choose to handle the error differently based on your use case.
        setLoading(false);
      });
  }

  const setNewRoleTypeParam = (Param) => {
    setNewRoleType(Param);

    var TypeDsc = RoleTypes.filter(x => x.Id === Param)[0]?.Detail;
    setTypeDsc(TypeDsc);

  }

  const setUserParam = (val) => {
    setUser(val);
    GetUserRoles(val?.Id);
  }

  useEffect(() => {
    getEmployeeRole();
    getBolgeAdiKoduData();
  }, []);

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      var Data = response.data;
      var newData = Data.filter((item) => item.BirimKodu !== "0");

      setBolgeAdiKodu(newData);
    }).catch((error) => {
    });

  }


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleOpenNewApplicationDialogUser = () => {
    setOpenNewApplicationDialogUser(true);
  };

  const handleCloseNewApplicationDialogUser = () => {
    setOpenNewApplicationDialogUser(false);
  };

  const handleAddNewApplicationUser = () => {
    if (!userCode || !userName || !userEmail || !userTopServiceShopCode || userBusinessType === -1) {
      setresponseMessage('Lütfen tüm alanları doldurunuz!...');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);

    const data = {
      "Name": userName,
      "UserCode": userCode,
      "Email": userEmail,
      "TopServiceShopCode": userTopServiceShopCode.BirimKodu,
      "BusinessType": userBusinessType
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    axios.post(`SetNewApplicationUser`, data, config).then((response) => {
      setLoading(false);
      if (response.data.ErrorCode === "0") {
        setresponseMessage(response.data.ErrorDescription);
        setUyariTip('success');
        setUyari(true);
        handleCloseNewApplicationDialogUser();
      } else {
        setresponseMessage(response.data.ErrorDescription);
        setUyariTip('error');
        setUyari(true);
      }
    }).catch((error) => {
      setLoading(false);
      setresponseMessage(error);
      setUyariTip('error');
      setUyari(true);
    });
  };


  return (
    <Page className={classes.root}>
      <ThemeCustomization>
        {
          loading ?
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Snackbar
          open={uyari}
          autoHideDuration={10000}
          onClose={uyariKapat}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage}
          ></Alert>
        </Snackbar>
        <Container maxWidth="xl">
          <Card>
            <CardHeader title={<Typography variant="h4">Apollo Yetki Yönetimi</Typography>} />
            <Divider />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={8}>
                  <SubCard title="İşlem" style={{ minHeight: 400 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel htmlFor="outlined-age-native-simple">Yetki Tipi</InputLabel>
                          <Select
                            label="Yetki Tipi"
                            value={NewRoleType}
                            onChange={(e) => setNewRoleTypeParam(e.target.value)}
                            fullWidth
                            size="small"
                            inputProps={{
                              name: 'age',
                              id: 'outlined-age-native-simple',
                            }}
                          >
                            {RoleTypes.map((type) => (
                              <MenuItem key={type.Id} value={type.Id}>
                                {type.Dsc}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={UsersData}
                          value={User}
                          noOptionsText="Kullanıcı bulunamadı"
                          getOptionLabel={(i) => i?.Dsc || ""}
                          onChange={(event, val) => setUserParam(val)}
                          onInputChange={(event, newInputValue) => {
                            handleUsers(newInputValue);
                          }}
                          fullWidth
                          renderInput={(params) => <TextField {...params} label="Kullanıcı"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingCombo && <CircularProgress color="primary" size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} style={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<PersonAddIcon />}
                          onClick={handleOpenNewApplicationDialogUser}
                          style={{
                            textTransform: 'none',
                            marginRight: 18
                          }}
                        >
                          Yeni Kullanıcı Tanımla
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ textTransform: 'none' }}
                          startIcon={<AccessibilityIcon />}
                          onClick={handleAddRole}>
                          Ekle
                        </Button>

                      </Grid>
                    </Grid>
                  </SubCard>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  <SubCard title="Yetki Bilgileri" style={{ minHeight: 400 }}>
                    {UserRolesData.length > 0 &&
                      UserRolesData.map((item) => (
                        <div key={item.Id}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography><b>Kullanıcı : </b>{`${item.User}`}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <Typography><b>Yetki : </b>{`${item.Role}`}</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                        </div>
                      ))}
                  </SubCard>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <Dialog open={openNewApplicationDialogUser} onClose={handleCloseNewApplicationDialogUser} aria-labelledby="form-dialog-title">
          {openNewApplicationDialogUser && (
            <>
              <DialogTitle id="form-dialog-title">Yeni Kullanıcı Oluştur</DialogTitle>
              <DialogContent>
                <Stack spacing={3}>
                  <DialogContentText>
                    <Typography variant="body2" component="span">
                      Eğer bir kullanıcıyı aradığınızda bulamadıysanız, yeni bir kullanıcı oluşturabilirsiniz.
                    </Typography>
                  </DialogContentText>
                  <TextField
                    autoFocus
                    value={userCode}
                    onChange={(e) => setUserCode(e.target.value)}
                    label="Sicil Numarası"
                    type="text"
                    fullWidth />
                  <TextField
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    label="Ad Soyad"
                    type="text"
                    fullWidth />
                  <TextField
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    label="Eposta"
                    type="email"
                    fullWidth />
                  <Autocomplete
                    autoFocus
                    value={userTopServiceShopCode}
                    options={bolgeAdiKodu}
                    getOptionLabel={option => (option.Dsc ? option.BirimKodu + ' - ' + option.Dsc : '')}
                    onChange={(event, newValue) => {
                      setUserTopServiceShopCode(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}

                  />
                  <Select
                    label="Yetki Tipi"
                    variant='outlined'
                    value={userBusinessType}
                    onChange={(e) => setUserBusinessType(e.target.value)}
                    fullWidth
                    size="small"

                  >
                    <MenuItem value={0}>Bölge</MenuItem>
                    <MenuItem value={2}>Müşteri Hizmetleri</MenuItem>
                    <MenuItem value={1}>Diğer</MenuItem>
                  </Select>
                </Stack>
              </DialogContent>
              <DialogActions sx={{ pr: 2.5 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                  onClick={handleCloseNewApplicationDialogUser}
                >
                  İptal
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: 'none' }}
                  onClick={handleAddNewApplicationUser}
                >
                  Oluştur
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </ThemeCustomization>
    </Page>
  );
};

export default Role;
